import api from './api';

const toVendorPayload = (vendorData = {}) => ({
    vendorName: String(vendorData?.vendorName ?? '').trim(),
    instructions: String(vendorData?.instructions ?? '').trim(),
});

const vendorService = {
    getAllVendors: async (searchQuery = '') => {
        try {
            const response = await api.get(`/vendors${searchQuery ? `?search=${searchQuery}` : ''}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching vendors:", error);
            throw error;
        }
    },

    createVendor: async (vendorData) => {
        try {
            const response = await api.post(`/vendors`, toVendorPayload(vendorData));
            return response.data;
        } catch (error) {
            console.error("Error creating vendor:", error);
            throw error;
        }
    },

    updateVendor: async (id, vendorData) => {
        try {
            const response = await api.put(`/vendors/${id}`, toVendorPayload(vendorData));
            return response.data;
        } catch (error) {
            console.error("Error updating vendor:", error);
            throw error;
        }
    },

    deleteVendor: async (id) => {
        try {
            const response = await api.delete(`/vendors/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting vendor:", error);
            throw error;
        }
    },

    uploadFile: async (vendorId, file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await api.post(`/vendors/${vendorId}/files`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error uploading file to vendor:", error);
            throw error;
        }
    },

    deleteFile: async (vendorId, fileKey) => {
        try {
            const response = await api.delete(`/vendors/${vendorId}/files?fileKey=${encodeURIComponent(fileKey)}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting file from vendor:", error);
            throw error;
        }
    },

    downloadFile: async (fileUrl) => {
        try {
            const response = await api.get(`/folders/files/download?url=${encodeURIComponent(fileUrl)}`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error("Error downloading file:", error);
            throw error;
        }
    }
};

export default vendorService;
